import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
export enum LOG_LEVEL {
  DEBUG,
  ERROR,
  MESSAGE,
}

/**
 * LoggerService
 * @export LoggerService
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  /**
   * Creates an instance of LoggerService.
   */
  constructor() {}

  /**
   * Logs out the incoming message only if the message is valid
   *
   * @param message The message to be logged
   * @param level The level of importance to determine if the message should be logged
   */
  static log(message: any, level: LOG_LEVEL) {
    switch (level) {
      case LOG_LEVEL.MESSAGE:
        if (environment.log.message) {
          this._log(message, 'MESSAGE');
        }
        break;
      case LOG_LEVEL.DEBUG:
        if (environment.log.debug) {
          this._log(message, 'DEBUG');
        }
        break;
      case LOG_LEVEL.ERROR:
        if (environment.log.error) {
          this._log(message, 'ERROR');
        }
        break;
    }
  }

  /**
   * _log function
   *
   * @private
   * @static
   * @param {*} msg
   * @param {string} lvl
   * @memberof LoggerService
   */
  private static _log(msg: any, lvl: string) {
    if (typeof(msg) === 'string') {
      console.log(
        lvl + ' - ' + new Date().toLocaleString() + ' - ' + msg,
      );
    } else {
      console.log(
        lvl + ' - ' + new Date().toLocaleString() + ' - ',
      );
      console.log(msg);
    }
  }
}
